var _rect, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _circle, _circle2, _circle3, _path7, _rect2, _path8, _path9, _path0, _path1, _polygon2, _path10, _path11, _circle4, _path12, _circle5, _circle6, _path13, _path14, _path15, _path16, _rect3, _rect4, _rect5, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _path26;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataAnalysis(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "#86_data analysis_twocolour") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69.42,
    y: 55.87,
    width: 232.26,
    height: 163.38,
    fill: "#e6e6e6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.86,
    cy: 264.96,
    rx: 86.26,
    ry: 13.81,
    fill: "#e6e6e6",
    opacity: 0.45
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200,138.56s-20.57,15.77-14.45,37.11,23.12,26.55,23.12,26.55v17.37l93-.33.35-37.18V97s-10.7-3-12,3.67-4,30.51-4.33,31.59-22.68-12.93-30,2.74l2.41,12.2L260,152l-.33,9.71-1.6,7.29L254,176l-4,6.08-6.78,5.55-7.81,4.16-17.64-2.13L205.07,175,200,159.94Z",
    opacity: 0.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M277.42,256.28s-1,3.42-4,3.85-3.66,3.43-.89,4.05,9.62-3.27,9.62-3.27l-.44-4.36Z",
    fill: "#336fd5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M320.94,259s1,3.42,4.05,3.84,3.65,3.44.88,4.06-9.62-3.27-9.62-3.27l.44-4.37Z",
    fill: "#336fd5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M342.49,254.58s-7.08-1.94-8.62-8.53c0,0,11-2.22,11.28,9.11Z",
    fill: "#336fd5",
    opacity: 0.58
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M343.36,253.88s-4.95-7.83-.59-15.14c0,0,8.34,5.3,4.63,15.15Z",
    fill: "#336fd5",
    opacity: 0.73
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M344.63,253.88s2.62-8.26,10.52-9.82c0,0,1.48,5.36-5.12,9.84Z",
    fill: "#336fd5"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "339.5 253.69 340.93 263.52 349.98 263.56 351.31 253.75 339.5 253.69",
    fill: "#24285b"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 89.86,
    cy: 72.17,
    r: 4.4,
    fill: "#24285b"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.95,
    cy: 72.17,
    r: 4.4,
    fill: "#336fd5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.29,
    cy: 72.17,
    r: 4.4,
    fill: "#ffd200"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M138.22,128.12a3.49,3.49,0,0,0-.65.06,3.8,3.8,0,0,0,.23-1.31,3.74,3.74,0,0,0-3.74-3.74,3.68,3.68,0,0,0-2.14.68,5.19,5.19,0,1,0-9.76,3.13,4.9,4.9,0,0,0-.77-.07,4.78,4.78,0,0,0-.21,9.55h17a4.16,4.16,0,1,0,0-8.31Z",
    fill: "#adadad"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 277.61,
    y: 38.23,
    width: 48.83,
    height: 35.65,
    fill: "#f7f7f7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M298.83,63h-.06a1.45,1.45,0,0,1-1.07-.55l-4.84-6.23a1.43,1.43,0,1,1,2.26-1.76l3.81,4.9,9.38-10.14a1.44,1.44,0,0,1,2.11,1.95L299.88,62.53A1.4,1.4,0,0,1,298.83,63Z",
    fill: "#adadad"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M225.66,215s25.75-11.63,30-37.63-3.48-46.46,26.41-53.56l3.56,30.56S285,206,227.34,221.67Z",
    fill: "#336fd5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M225.66,215s25.75-11.63,30-37.63-3.48-46.46,26.41-53.56l3.56,30.56S285,206,227.34,221.67Z",
    fill: "#fff",
    opacity: 0.46
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M298.21,101.76s-2.23,5.2-2.5,9a2.84,2.84,0,0,0,2.65,3,6.27,6.27,0,0,0,6.13-3l3.15-4.16a5.07,5.07,0,0,0-.43-5.85C304.9,97.71,299.4,98.53,298.21,101.76Z",
    fill: "#f4a28c"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "306.42 107.63 305.94 126.14 295.75 125.15 300.19 112.08 306.42 107.63",
    fill: "#f4a28c"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M299.46,102.42a22.6,22.6,0,0,0,5.08,1.25,4.72,4.72,0,0,0-1.62,4.92,3.84,3.84,0,0,0,3.92,2.9l2.19-6.92a5.76,5.76,0,0,0-1.17-5.79,21.6,21.6,0,0,0-1.93-1.89c-1.72-1.45-5.07-1.08-6.4-3a1.37,1.37,0,0,0-2.34.18c-1,2-1.71,5.42.75,7.5A5.19,5.19,0,0,0,299.46,102.42Z",
    fill: "#24285b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M302.4,108.24s.72-2.06,2.22-1.39.48,3.65-1.73,3.23Z",
    fill: "#f4a28c"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.39,
    cy: 159.94,
    r: 27.68,
    fill: "#fff",
    opacity: 0.22
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M297,105.11l-2.17,1.57a.91.91,0,0,0,.09,1.53l1.92,1.06Z",
    fill: "#f4a28c"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.41,
    cy: 148.67,
    r: 8.61,
    fill: "#fff",
    opacity: 0.41
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.91,
    cy: 167,
    r: 5.29,
    fill: "#fff",
    opacity: 0.41
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M299.68,113.76a6.66,6.66,0,0,0,3.78-.72s-.49,3.39-5.13,5.25Z",
    fill: "#ce8172",
    opacity: 0.31
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M285.34,123.47s43,1.76,55.38,11.21-28.21,72-28.21,72l-41.35-7.16S244.56,125.11,285.34,123.47Z",
    fill: "#336fd5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M321.94,140.87s-14.42,7-9.43,20.84-3.82,31.63-23.29,41l23.29,4s19.21-30.73,22.72-40.59S321.94,140.87,321.94,140.87Z",
    opacity: 0.08
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M321.14,142.37c4.28-9.3,16.56-11.6,24.26-4.87,10.74,9.41,25.33,26.37,25.8,49.5C372,223.75,318,207.2,318,207.2l2.25-8.2s36,4,29.5-16.25C344.47,166.44,313.74,158.47,321.14,142.37Z",
    fill: "#336fd5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 229.63,
    y: 189.91,
    width: 10,
    height: 71.37,
    transform: "translate(-14.01 15.54) rotate(-3.68)",
    fill: "#ffd200"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 229.63,
    y: 189.91,
    width: 10,
    height: 71.37,
    transform: "translate(-14.01 15.54) rotate(-3.68)",
    opacity: 0.08
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 226.91,
    y: 208.18,
    width: 17,
    height: 56.83,
    transform: "translate(-14.71 15.61) rotate(-3.68)",
    fill: "#24285b"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M321.14,142.37c4.28-9.3,16.56-11.6,24.26-4.87,10.74,9.41,25.33,26.37,25.8,49.5C372,223.75,318,207.2,318,207.2l2.25-8.2s36,4,29.5-16.25C344.47,166.44,313.74,158.47,321.14,142.37Z",
    fill: "#fff",
    opacity: 0.46
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M271.16,199.54l4.51,57.29H283s-3.33-38.5,9.67-46.16l19.84-4Z",
    fill: "#24285b"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M312.51,206.7l9.82,52.63-7.21.94S307,215.67,287,210.67Z",
    fill: "#24285b"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M319.69,200.85s-8.75-1.68-9.41,6,5.67,4.73,7.67.37Z",
    fill: "#f4a28c"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M225.66,215s-8.17,7.06-.34,9.17C229.67,225.3,225.66,215,225.66,215Z",
    fill: "#f4a28c"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M129.49,164.56a34.72,34.72,0,1,1,34.72-34.72A34.76,34.76,0,0,1,129.49,164.56Zm0-60.08a25.37,25.37,0,1,0,25.37,25.36A25.4,25.4,0,0,0,129.49,104.48Z",
    fill: "#c9c9c9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M129.49,164.56a34.64,34.64,0,0,1-23-8.74l6.2-7a25.39,25.39,0,0,0,16.83,6.38Z",
    fill: "#24285b"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M164.21,129.84h-9.35a25.4,25.4,0,0,0-25.37-25.36V95.13A34.76,34.76,0,0,1,164.21,129.84Z",
    fill: "#336fd5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M129.49,164.56v-9.35a25.4,25.4,0,0,0,25.37-25.37h9.35A34.76,34.76,0,0,1,129.49,164.56Z",
    fill: "#ffd200"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 117.98,
    y: 177.54,
    width: 32.36,
    height: 9.07,
    fill: "#c9c9c9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 98.55,
    y: 177.54,
    width: 12.4,
    height: 9.07,
    fill: "#336fd5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 98.55,
    y: 193.15,
    width: 12.4,
    height: 9.07,
    fill: "#24285b"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 117.98,
    y: 193.15,
    width: 32.36,
    height: 9.07,
    fill: "#c9c9c9"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 185.55,
    y: 98.88,
    width: 64.45,
    height: 13.61,
    fill: "#fff"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 230.39,
    y: 98.88,
    width: 19.61,
    height: 13.61,
    fill: "#24285b"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M232.73,195a36.43,36.43,0,1,1,34-38.69A36.46,36.46,0,0,1,232.73,195Zm-4-61.61A25.31,25.31,0,1,0,255.65,157,25.34,25.34,0,0,0,228.76,133.36Z",
    fill: "#ffd200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataAnalysis);
export default __webpack_public_path__ + "static/media/data_analysis.15049787c0ac9f42da396d64caf88215.svg";
export { ForwardRef as ReactComponent };